module.exports = __webpack_public_path__ + "744ac327.svg";